import React from 'react';
import utils from '@nykaa/deals-utils/basic';
import { Wrapper, ColumnWrapper, ListWrapper, DesktopBgWrapper, } from './css';
import SectionHeader from '../SectionHeader';
const ColumnGridV2 = (widgetData) => {
    const { params, children, cssStyle, isDesktop, id, remoteConfigs, } = widgetData;
    const { title, titleAlign, columnsInRow = 1, imageUrl, description, isFullWidth, bkgColor, buttonData, } = params;
    const { switches, } = remoteConfigs;
    const columnWidth = (100 / columnsInRow);
    const numberPattern = /\d+/g;
    let interItemVal = 16;
    if (cssStyle
        && cssStyle.spacingStyle
        && cssStyle.spacingStyle.interItem
        && cssStyle.spacingStyle.interItem.web) {
        interItemVal = +cssStyle.spacingStyle.interItem.web.match(numberPattern).join('.') * 16;
    }
    const { isEmptyWidget } = utils;
    const checkEmptyWidget = isEmptyWidget(title, description, children, switches);
    return (React.createElement(DesktopBgWrapper, { className: "parent", id: id, color: bkgColor, isDesktop: isDesktop, setEmptyWidget: checkEmptyWidget },
        React.createElement(Wrapper, { padding: cssStyle.spacingStyle.padding, align: titleAlign, color: bkgColor, isDesktop: isDesktop, isFullWidth: isFullWidth, interItemMargin: interItemVal / 2, interItemRaw: cssStyle.spacingStyle.interItem.web },
            imageUrl && React.createElement("img", { src: imageUrl, alt: title }),
            React.createElement(SectionHeader, { isDesktop: isDesktop, cssStyle: cssStyle, title: title, description: description, buttonData: buttonData }),
            React.createElement("div", { className: isDesktop ? 'fixed-width-wrapper' : 'list-wrap' },
                React.createElement(ListWrapper, { isDesktop: isDesktop, interItemMargin: interItemVal / 2, className: "columngrid-row", width: columnWidth, padding: cssStyle.spacingStyle.padding }, children
                    && children.map((column) => (React.createElement(ColumnWrapper, { className: "column-child", interItemMargin: interItemVal / 2, key: `${column.key}_colWrap`, width: columnWidth, isDesktop: isDesktop }, column))))))));
};
export default ColumnGridV2;
